import React from 'react';
import {
  Navigate, Route, Routes, useParams, useSearchParams,
} from 'react-router-dom';
import UserSearchPage from './UserSearchPage';
import type { UserSearchLayout } from './UserSearchPage';

// Old detail URLs (/staffer/:id) still arrive from bookmarks and impersonation return
// paths — fold them into the split view's ?selected= param.
const DetailRedirect = () => {
  const { userType, id } = useParams();
  const [searchParams] = useSearchParams();
  const next = new URLSearchParams(searchParams);
  next.set('selected', `${userType}:${id}`);

  return <Navigate replace to={{ pathname: '/', search: next.toString() }} />;
};

export const UserSearchRoutes = ({ layout }: { layout: UserSearchLayout }) => (
  <Routes>
    <Route element={<UserSearchPage layout={layout} />} path="/" />
    <Route element={<DetailRedirect />} path="/:userType/:id" />
  </Routes>
);

export default UserSearchRoutes;
